import React, { Component } from "react";
import classnames from "classnames";
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { showMainErrorPop } from '../../actions/popups';

import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class ForgotPasswordContent extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		emailInput: '',
		errorEmail: false
	}
}
 
componentDidMount(){
	axiosVirdio = new axiosVirdioT(this.props);
}

validateEmail=(mail)=>{
	var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
	if ( mail.match(validRegex) ) 
		{
			return true;
		}
		
	return false;
}

submitForm=()=>{
	var canSubmitForm = true;
	
	if ( !this.validateEmail(this.state.emailInput) )
		{
			canSubmitForm = false;
			this.setState({errorEmail: true});
			this.props.showMainErrorPop('Please enter valid email.');
		}
		
	if ( canSubmitForm )
		{
			const userData = { email: this.state.emailInput };
			
			this.props.updateStateFromChild({showLoader: true});
			axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/user/forgotpassword",userData).then(res => {
				this.props.updateStateFromChild({showLoader: false});
				this.props.showMainErrorPop(res.data.responseData.message);
			}).catch(err =>{
				this.props.updateStateFromChild({showLoader: false});
			});
		}
}

  render() {
	 return (
		<div className="login_content">
			<div className="exit_content">
				<Link to="/login">
					<div className="inline_event">
						<div className="arrow_exit"></div>
						<div className="exit_screen">EXIT</div>
					</div>
				</Link>
			</div> 
			<div className="sign_title">Forgot Password</div>
			<div className="form_login_content">
				<div className="one_form_container">
					<div className="form_title">Email</div>
					<div className="relative_holder">
						<input type="text" autoComplete="off" className={classnames({'gray_inputs': true, 'error_input': this.state.errorEmail})} id="emailInput" value={this.state.emailInput} onChange={(e)=>this.setState({[e.target.id]:e.target.value, errorEmail: false})} />
						{ this.state.emailInput !== '' &&
							<div className="empty_input" onClick={()=>this.setState({emailInput: ""})}></div>
						}
					</div>
				</div>
				<div className="sing_in_content">
					<div className={classnames({'inline_event': true, 'opacity_event': this.state.emailInput == ''})} onClick={() => this.state.emailInput == '' ? {} : this.submitForm()}>
						<div className="sign_title_small">SUBMIT</div>
						<div className="arrow_next"></div>
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default connect(
  null,
  { 
	showMainErrorPop
  }
)(ForgotPasswordContent);
